import moment from 'moment';
import apiClient from '@shared/lib/general/apiClient';
import {
  COMFORT_CREDITS_CHANGE_VALUE,
  COMFORT_CREDITS_CHANGE_VALUES,
  COMFORT_CREDITS_CHANGE_TABLE_OPTION,
  VOUCHERS_CHANGE_TABLE_OPTION,
} from '@/store/constants/mutationTypes';

const actions = {
  changeComfortCreditValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: COMFORT_CREDITS_CHANGE_VALUE,
      field,
      value,
    });
  },
  changeComfortCreditValues({ commit }, payload) {
    commit({
      type: COMFORT_CREDITS_CHANGE_VALUES,
      changes: payload,
    });
  },
  ccChangeTableOption({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: COMFORT_CREDITS_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  vvChangeTableOption({ commit }, payload) {
    const {
      field,
      value,
    } = payload;
    commit({
      type: VOUCHERS_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  async getAllCorpCustomers(_, corpId) {
    const { data } = await apiClient({
      method: 'GET',
      url: `customers/corporation/${corpId}?status=Active`,
    });
    return data;
  },
  async getComfortCredits({ commit, rootState, state }) {
    commit({
      type: COMFORT_CREDITS_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });

    try {
      const {
        admin: {
          adminFilter: {
            corpId,
          },
        },
      } = rootState;

      const {
        ccTableOptions: {
          itemsPerPage,
          page,
        },
        ccTableSearch,
        activeTab,
        balanceAsOfDate,
        lastCCDate,
        selectedPlan,
      } = state;
      let url = `/comfort/credits/rewards/corp/${corpId}`;
      if (activeTab === 'credits') {
        const end = moment(balanceAsOfDate).format('YYYY-MM-DD');
        url += `?end=${end}`;
      } else {
        const start = moment(lastCCDate.start).format('YYYY-MM-DD');
        const end = moment(lastCCDate.end).format('YYYY-MM-DD');
        url += `?start=${start}&end=${end}`;
      }
      if (selectedPlan) {
        url += `&planId=${selectedPlan}`;
      }
      if (ccTableSearch) {
        url += `&search=${ccTableSearch}`;
      }
      if (page) {
        url += `&offset=${page}`;
      }
      if (itemsPerPage) {
        url += `&limit=${itemsPerPage}`;
      }
      const { data: rewards } = await apiClient({
        method: 'GET',
        url,
      });

      const list = rewards.data;

      commit({
        type: COMFORT_CREDITS_CHANGE_VALUES,
        changes: [{
          field: 'ccMembers',
          value: list,
        }, {
          field: 'loading',
          value: false,
        }, {
          field: 'ccTableOptions',
          value: {
            page: rewards.page,
            itemsPerPage: rewards.pageSize,
            totalItems: rewards.totalCount,
          },
        }],
      });
    } catch (err) {
      commit({
        type: COMFORT_CREDITS_CHANGE_VALUE,
        field: 'loading',
        value: false,
      });
      throw err;
    }
  },
  async removeVoucher({ dispatch }, voucherIds) {
    try {
      await apiClient({
        method: 'POST',
        url: '/vouchers/remove',
        data: voucherIds,
      });
      dispatch('getCorpVouchers');
      dispatch('showSuccessToast', {
        message: 'New transaction completed.',
      });
    } catch (error) {
      dispatch('showAlertToast', {
        message: 'There was an unexpected error. Please try again or contact support',
      });
    }
  },
  async postComfortCredits({ state, dispatch }) {
    const {
      transaction: {
        amount,
        reason,
        rewardType,
        corpId,
        customerId,
      },
    } = state;
    let url;
    let requestBody;
    if (rewardType === 'credits') {
      url = '/comfort/credits/new/amount';
      requestBody = {
        customerId,
        amount,
        reason,
        actionCode: 'Manual',
        creditDate: moment().format('YYYY-MM-DD'),
      };
    } else {
      url = '/vouchers/new';
      requestBody = {
        customerId,
        amount,
        reason: 'Manual',
        description: 'From NOC',
        issuedDate: moment().format('YYYY-MM-DD'),
      };
    }
    try {
      await apiClient({
        method: 'POST',
        url,
        data: requestBody,
      });
      dispatch('getComfortCredits');
      dispatch('getCorpVouchers', corpId);
      dispatch('showSuccessToast', {
        message: 'New transaction completed.',
      });
    } catch (error) {
      dispatch('showAlertToast', {
        message: 'There was an unexpected error. Please try again or contact support',
      });
    }
  },
  async getCustomerVouchers(_, customerId) {
    const { data } = await apiClient({
      method: 'GET',
      url: `vouchers/customer/${customerId}`,
    });
    return data;
  },
  async getCorpVouchers({ commit, state, rootState }, selectedCorp) {
    const {
      admin: {
        adminFilter: {
          corpId,
        },
      },
    } = rootState;
    const {
      activeTab,
      balanceAsOfDate,
      lastCCDate,
      selectedCustomerId,
      redeemed,
    } = state;
    let sendCorp;
    if (selectedCorp) {
      sendCorp = selectedCorp;
    }
    sendCorp = corpId;
    let url = `/comfort/credits/transactions/corp/${sendCorp}`;
    if (activeTab === 'credits') {
      const end = moment(balanceAsOfDate).format('YYYY-MM-DD');
      url += `?end=${end}`;
    } else {
      const start = moment(lastCCDate.start).format('YYYY-MM-DD');
      const end = moment(lastCCDate.end).format('YYYY-MM-DD');
      url += `?start=${start}&end=${end}`;
    }
    if (selectedCustomerId) {
      url += `&customerId=${selectedCustomerId}`;
    }
    if (redeemed !== null) {
      url += `&redeemed=${redeemed}`;
    }
    const { data } = await apiClient({
      method: 'GET',
      url,
    });
    commit({
      type: COMFORT_CREDITS_CHANGE_VALUE,
      field: 'vouchers',
      value: data,
    });
  },
};

export default actions;
